import React, { Component } from 'react';

import SearchFilter from './SearchFilter';

import SearchBox from '../../components/SearchBox/index';
import { searchDevices } from '../../util/aws-manager';

class SearchModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toggleBool: false,
      searchBox: false,
      searchText: props.defaultText,
      dataSource: 'Header',
      showMoreDevices: null,
      content: null,
      initialDigit: 0,
      totalRecords: 0,
      count: 0,
    };

    this.onButtonClick.bind(this);
    this.technologyTypeChanged.bind(this);
    this.accessTypeChanged.bind(this);
    this.locationChanged.bind(this);
    this.notificationTypeChanged.bind(this);
    this.incidentPriorityChanged.bind(this);
    this.rspChanged.bind(this);
    this.sdpChanged.bind(this);
  }


  queryData;

  technologyTypeSelectedArray = [];
  accessTypeSelectedArray = [];
  locationSelectedArray = [];
  notificationTypeSelectedArray = [];
  incidentPrioritySelectedArray = [];
  rspSelectedArray = [];
  sdpSelectedArray = [];
  searchModalPageNumber = 1;
  dataSource = [];
  searchedData = [];

  technologyTypeChanged = (selected) => {
    this.technologyTypeSelectedArray = selected;
  }

  accessTypeChanged = (selected) => {
    this.accessTypeSelectedArray = selected;
  };

  locationChanged = (selected) => {
    this.locationSelectedArray = selected;
  };

  notificationTypeChanged = (selected) => {
    this.notificationTypeSelectedArray = selected;
  };

  incidentPriorityChanged = (selected) => {
    this.incidentPrioritySelectedArray = selected;
  };

  rspChanged = (selected) => {
    this.rspSelectedArray = selected;
  };

  sdpChanged = (selected) => {
    this.sdpSelectedArray = selected;
  };


  toggleFilter = () => {
    this.setState({
      toggleBool: !this.state.toggleBool,
    });
  };

  updateSearchText(evt) {
    this.setState({
      searchText: evt.target.value,
    });
  }

  onButtonClick = () => {
    this.searchModalPageNumber = 1;
    this.searchedData = [];
    if (this.state.searchText) {
      this.searchedDeviceData(this.state.searchText, this.searchModalPageNumber);
    };
  }
  showMoreButtonClick = () => {
    this.searchModalPageNumber = this.searchModalPageNumber + 1;
    this.searchedDeviceData(this.state.searchText, this.searchModalPageNumber);
  }

  unique = (value, index, self) => {
    return self.indexOf(value) === index
  }

  searchedDeviceData = (searchText, pagenumber) => {
    searchDevices(searchText, pagenumber)
      .then((data) => {
        const uniqueSearchResults = data.filter(this.unique);
        this.queryData = uniqueSearchResults;
        this.setState({
          dataSource: 'Modal',
        });
        this.setData();
      }, () => {
      });
  }


  setData = () => {
    let initialDigit = 0,
      buttonValue = '', totalRecords = 0, count = 0;

    if (this.state.dataSource === 'Modal') {
      this.dataSource = this.queryData;
      totalRecords = this.queryData.Count;
    }
    else if (this.state.dataSource === 'Header') {
      this.dataSource = this.props.data;
      totalRecords = this.props.data.Count;
    }
    if (this.dataSource) {
      this.dataSource.forEach((item) => {
        this.searchedData.push(item);
      });
      // if (this.searchedData.length != this.dataSource.Count) {
      //   buttonValue = (<button id="showMore-button"
      //     className="btn mr-3"
      //     onClick={() => {
      //       this.showMoreButtonClick();
      //     }}
      //   >Show More...</button>);
      // }
      // else {
      //   buttonValue = '';
      // }
      buttonValue = '';
    }
    const content = this.searchedData.map((el, index) => {
      if (el) {
        return (
          <tr key={index}>
            <td>{el}</td>
            <td><a onClick={() => {
              this.props.onViewPitClick(el);
            }}
            >View Pit</a></td>
          </tr>
        );
      }

      return null;
    });

    if (this.searchedData.length > 0) {
      initialDigit = 1;
    }

    this.setState({
      content: content,
      showMoreDevices: buttonValue,
      initialDigit: initialDigit,
      totalRecords: totalRecords,
      count: this.searchedData.length,
    });
  };

  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.onButtonClick();
    }
  };

  componentDidMount() {
    const self = this;
    $('.inner-height').slimscroll({
      height: '100%'
    });
    $('#searchModal').on('hidden.bs.modal', () => {
      self.props.clearSearchText();
    });
  }
  componentWillMount() {
    this.setData();
  }
  render = () => {
    return (
      <div className="modal fade temprature-popupWrapper" id="searchModal">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            {/* Header starts */}
            <div className="modal-header py-2 border-0">
              <div className="col-12">
                <div className="row">
                  <div className="col-9">
                    <h4 className="modal-title">Search Results</h4>
                  </div>
                  <div className="col-3">
                    <div className="row">
                      <div className="d-flex align-items-center justify-content-end col-6">
                        <h5 className="mb-0 pl-2" />
                      </div>
                      <div className="d-flex align-items-center col-6 justify-content-end">
                        <button type="button" className="close" data-dismiss="modal">
                          <h6 className='input-for-search'>&times;</h6><h4 className="pl-1 modal-title">Close</h4></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Header ends */}
            <div className="modal-body">
              {/* <button id="back-button" className="btn mr-3">&lt; &lt; Back</button> */}
              {/* <span>Displaying Results {this.state.initialDigit} to {this.state.count} (of {this.state.totalRecords})</span> */}
              {/* <span>Displaying Results {this.state.initialDigit} to {this.state.count}</span> */}

              <div className="d-flex">
                {/* <button className="btn-filter d-inline-block" onClick={this.toggleFilter}><i
                  className="fa-fw fa-filter fa text-black"
                  aria-hidden="true"
                /> Filter
                  </button> */}
                <SearchBox
                  onChange={this.updateSearchText.bind(this)}
                  value={this.state.searchText}
                  onKeyPress={this.handleKeyPress.bind(this)}
                  onButtonClick={this.onButtonClick}
                />
              </div>
              {/* //Filters */}
              {/*-------------------------------------------------------------*/}

              <div className="mx-4 mb-4">
                {this.state.toggleBool ? <SearchFilter
                  technologyTypeChanged={(array) => {
                    this.technologyTypeChanged(array);
                  }}
                  accessTypeChanged={(array) => {
                    this.accessTypeChanged(array);
                  }}
                  locationChanged={(array) => {
                    this.locationChanged(array);
                  }}
                  notificationTypeChanged={(array) => {
                    this.notificationTypeChanged(array);
                  }}
                  incidentPriorityChanged={(array) => {
                    this.incidentPriorityChanged(array);
                  }}
                  rspChanged={(array) => {
                    this.rspChanged(array);
                  }}
                  sdpChanged={(array) => {
                    this.sdpChanged(array);
                  }}
                /> : ''}
              </div>

              {/*-------------------------------------------------------------*/}

              <div className="inner-height">
                {this.state.content.length > 0 ? (<table className="table search-table mt-3 table-bordered">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>View</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.content}
                  </tbody>
                </table>) : <h3>No results to display</h3>}
              </div>
              {this.state.showMoreDevices}
            </div>
          </div>
        </div>
      </div>
    );
  };
}

export default SearchModal;



// WEBPACK FOOTER //
// ./components/Header/SearchModal.js